import styles from "./BannerHint.module.css";
import type { DetonateHintVariantProps } from "./types";

/** Pattern B: a blast-colored banner dropping in from the top. */
export default function BannerHint({ input }: DetonateHintVariantProps) {
  return (
    <div className={styles.root} role="status">
      <span className={styles.dot} />
      <b>BLAST READY</b>
      <span className={styles.divider} />
      <span>{input === "key" ? <><kbd>SPACE</kbd> で爆発</> : "タップで爆発"}</span>
    </div>
  );
}
